module.exports = __webpack_public_path__ + "media/images/common/ogp-bdacffefa7cee0c7fd684116263deb10.png";